import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { FieldEdition } from '../../1d-2d/FieldEdition';
import { useChartData } from '../../context/ChartContext';
import { useDispatch } from '../../context/DispatchContext';
import { useActiveSpectrumRangesViewState } from '../../hooks/useActiveSpectrumRangesViewState';
import { useTriggerNewAssignmentLabel } from '../../hooks/useTriggerNewAssignmentLabel';
const marginTop = 15;
export function AssignmentLabel(props) {
    const { range, width } = props;
    const { id, assignment } = range;
    const { showAssignmentsLabels } = useActiveSpectrumRangesViewState();
    const dispatch = useDispatch();
    const textRef = useRef(null);
    const { margin } = useChartData();
    const { isNewAssignment, dismissNewLabel } = useTriggerNewAssignmentLabel(id);
    if ((!range.assignment || !showAssignmentsLabels) && !isNewAssignment) {
        return null;
    }
    function handleChange(value) {
        dismissNewLabel();
        dispatch({
            type: 'CHANGE_RANGE_ASSIGNMENT_LABEL',
            payload: {
                value,
                rangeID: id,
            },
        });
    }
    return (_jsx("g", { transform: `translate(${width / 2} ${margin?.top + marginTop})`, children: _jsx(FieldEdition, { onChange: handleChange, inputType: "text", value: assignment || '', PopoverProps: {
                position: 'bottom',
                targetTagName: 'g',
                ...(isNewAssignment
                    ? { isOpen: true, onClose: () => dismissNewLabel() }
                    : {}),
            }, children: _jsx("text", { ref: textRef, textAnchor: "middle", fill: "black", style: { cursor: 'hand' }, width: width, children: assignment }) }) }));
}
